export default "__VITE_ASSET__CWeRjEtw__"